<template>
  <b-container>
      <div>        
      <h3 class="text-center pt-4 pb-4">{{ obj.title }}</h3>
      <div class="mb-2"><b-form-checkbox v-model="lg" name="check-button" switch>lg <b>({{ lg ? 'fr' : 'en' }})</b></b-form-checkbox></div>

      <b-row>
        <b-col md="6">
          <div>{{ $t("label.list") }}</div>
          <hr/>
            <b-list-group>
                <draggable v-model="list" group="item" @start="drag=true" @end="drag=false">
                    <b-list-group-item class="dragItem d-flex justify-content-between align-items-center" v-for="item in list" :key="item.Id">
                      {{lg ? item.fr : item.en}}
                      <b-button @click="editItemList(item)" size="sm" variant="link">{{ $t("label.edit") }}</b-button>
                    </b-list-group-item>
                </draggable>
            </b-list-group>
        </b-col>        
        <b-col md="6">    
          <div>{{ $t("action.drop") }}</div>
          <hr/>
            <b-list-group>
                <draggable v-model="removedList" group="item" @start="drag=true" @end="drag=false">
                    <b-list-group-item class="dragItem" v-for="item in removedList" :key="item.Id">{{lg ? item.fr : item.en}}</b-list-group-item>
                </draggable>
            </b-list-group>
        </b-col>
    </b-row>
    
    <b-row class="mt-2">
        <b-col>
            <b-button class="text-center" variant="success" @click="addItem('addItemModal')">+</b-button>    
            <b-button class="ml-2" variant="warning" @click="resetList()">{{ $t("action.reload") }}</b-button>            
        </b-col>
    </b-row> 

    <b-row class="mt-2">
        <b-col>
            <b-button class="mt-4 mr-2" variant="success" @click="submitNewList()">{{ $t("action.submit") }}</b-button>            
        </b-col>
    </b-row> 

    <b-modal id="modalItem" :title="$t('action.add')" hide-footer>
      <AddItemToList modalid="modalItem" :item="value" :source="source" :mode="mode"/>
    </b-modal>

    <div v-if="spinner" class="text-center">
      <b-spinner style="width: 3rem; height: 3rem;" variant="success" label="Spinning" disabled="labelStatus"></b-spinner>
    </div>

    <div v-if="success" class="pt-4">
      <b-alert show variant="success">
        <p>{{ $t("info.successgeneric") }}</p>
      </b-alert>
    </div>

    <div v-if="error" class="pt-4">
      <b-alert show variant="danger">
        <p>{{ error }}</p>
      </b-alert>
    </div>

    </div>
  </b-container>
</template>

<script>
import axios from 'axios';
import { globalF } from '../../Helpers';
import draggable from 'vuedraggable';
import AddItemToList from './AddProvenanceToList.vue';

export default {
mixins: [globalF],
props: ["request", "source"],
data() {
    return {
        disabled: false,
        list: [],  
        removedList: [],  
        all: [],    
        success: false,
        error: "",
        spinner: false,
        value: null,
        mode: "",
        lg: false
    }
},
mounted () {
    this.$root.$on('bv::modal::hide', () => {
            let reloadvalue = this.$store.getters.getReload;
            if (reloadvalue) {
              this.getData();
            }
    })
    this.getData();
},
computed: {
    obj: function () {
        let title = this.$t("action.editReference");
        return {
            title: title
        }
    },
    url: function () {
    let urls = this.$store.getters.getUrlsList;
    return urls[process.env.VUE_APP_WHERE].json;
  }
},
methods:{
  addItem: function () {
    this.value = null;
    this.mode = "insert";
    this.$bvModal.show("modalItem");
  },
  editItemList: function (item) {
    this.value = item;
    this.mode = "update";
    this.$bvModal.show("modalItem");
  },
  resetList: function () {        
    this.removedList = [];
    let prov = this.all.map((a) => {return a});
    prov.sort(function(a, b){return a.listOrder-b.listOrder});
    this.list = prov;
  },
  getData() {
    this.spinner = true;
    axios.post(this.url, {request: this.request}, { headers: {'Content-Type': 'application/json'}})
         .then((response)  => {
           this.spinner = false;
           this.disabled = false;
           this.$store.commit('setReloadValue', false);
           if (response.data.list) { 
             let list = response.data.list;
             this.removedList = [];
             this.all = list.map((a) => {return a});
             let newList = list.map((a) => {return a});
             newList.sort(function(a, b){return a.listOrder-b.listOrder});
             this.list = newList;
           }
           else {
             this.error = response.status;   
           }
         })
         .catch((error)  => {
           this.error = error;
           this.disabled = false;
           this.spinner = false;
         });
  },
  prepareList: function () {
    let ct = 0;
    let list = this.list.map((a) => {a.listOrder = ct += 1; return a});
    let rl = this.removedList.map((a) => {a.status = 2; return a});

    return list.concat(rl);

  },
  submitNewList() {
      
      this.success = false;
      this.error = "";     
      this.spinner = true;
      this.disabled = true;

      let promise = this.validateToken();  
        promise.then(() => {

          let list = this.prepareList();

          axios.post(this.url, {request: "updateMenu", source: this.source, list: list }, { headers: {'Content-Type': 'application/json'}})
          .then((response)  => {
            let res = response.data;
            
            if (res === 0) {
              this.success = true;
              this.getData();
            }
            else {
              this.spinner = false;
              this.disabled = false;
              this.error = response.status;   
            }
          })
          .catch((error)  => {
            this.error = error;
            this.disabled = false;
            this.spinner = false;
          });
        });
  }
},
components: {
    draggable,
    AddItemToList
}
}
</script>
